import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UnreadNotificationsCounterUpdatedSubscriptionVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type UnreadNotificationsCounterUpdatedSubscriptionResult = { __typename?: 'Subscription' } & Pick<
  GraphQLTypes.Subscription,
  'unreadNotificationsCounterUpdated'
>;

export const UnreadNotificationsCounterUpdatedDocument = gql`
  subscription unreadNotificationsCounterUpdated {
    unreadNotificationsCounterUpdated
  }
`;
